export default __webpack_public_path__ + "static/media/profileImg7.5efe4f0c.png";